import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtnaPopoverModule, MtnaSearchBoxModule, MtnaSelectSearchModule } from '@mtna/core-angular';

import { RdsChipsModule } from '../chips/index';
import { RdsCodeSelectModule } from '../code-select';
import {
  CoerceFilterByCodesPipeModule,
  RdsFilterSummaryChipsPipeModule,
  RdsFirstItemInArrayPipeModule,
  RdsGetVariableDisplayPipeModule,
  RdsPopoverAriaLabelPipeModule,
  RdsVariableFilterTypePipeModule,
} from '../core/pipes/index';
import { RdsDateFilterModule } from '../date-filter/index';
import { RdsNullFilterModule } from '../null-filter/index';
import { RdsNumericFilterModule } from '../numeric-filter/index';
import { RdsTextFilterModule } from '../text-filter/index';
import { RdsFilterDialogComponent } from './filter-dialog.component';
import { RdsFilterSelectComponent } from './filter-select.component';
import { FilterTypeSubtitlePipe } from './filter-type-subtitle.pipe';
import { RdsGetFilterValuePipe } from './get-select-value.pipe';

const COMPONENTS = [RdsFilterDialogComponent, RdsFilterSelectComponent];
const PIPES = [RdsGetFilterValuePipe, FilterTypeSubtitlePipe];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    CoerceFilterByCodesPipeModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatOptionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MtnaPopoverModule,
    MtnaSearchBoxModule,
    MtnaSelectSearchModule,
    RdsChipsModule,
    RdsCodeSelectModule,
    RdsDateFilterModule,
    RdsFilterSummaryChipsPipeModule,
    RdsFirstItemInArrayPipeModule,
    RdsGetVariableDisplayPipeModule,
    RdsNullFilterModule,
    RdsNumericFilterModule,
    RdsPopoverAriaLabelPipeModule,
    RdsTextFilterModule,
    RdsVariableFilterTypePipeModule,
    ScrollingModule,
  ],
  exports: [COMPONENTS],
  declarations: [COMPONENTS, PIPES],
  entryComponents: [RdsFilterDialogComponent],
})
export class RdsFilterModule {}

export * from './filter-select.component';
export * from './filter-dialog.component';
